import { styled } from '../theme';

const PageTileBody = styled('section')(({ theme }) => ({
    marginTop: 40,
    marginBottom: 40,
}));

export default PageTileBody;
